var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconZegalSignTeal = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.2 14.7h2.5v-2.5h1.7l-3-3-3 3h1.7l.1 2.5zm-1.7.9h5.9v.9H6.5v-.9z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.7 17.6h-6V3.8h5.6v4h4v4.3h1.6V7l-4.8-4.8H4.7c-.9 0-1.6.7-1.6 1.6v13.8c0 .9.7 1.6 1.6 1.6h6.1v-1.6z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.6 14.7c.4-.4.7-.7.9-.6.3.1 0 .5-.2.8-.1.2-1.4 2-1.4 3.2 0 .6.2 1.1.7 1.5.4.3.9.4 1.3.2.5-.2 1-.7 1.5-1.4.6-.8 1.4-1.7 2.1-1.7.8 0 .8.5.9.9-1.4.2-2.5 1.3-2.7 2.7 0 .9.7 1.6 1.6 1.6.8 0 2.2-.7 2.4-3.1h1.2v-1.3h-1.2c0-1.1-.9-2.1-2-2.1-1 .1-1.9.6-2.5 1.4-.3.4-1 1.2-1.2 1.4-.1.2-.3.4-.6.4s-.4-.4-.2-1 .6-1.2.9-1.8c.4-.5.6-1 .7-1.6.1-.7-.5-1.4-1.2-1.4h-.1c-.5 0-1 .3-1.4.6-.2.2-.3.3-.4.5l.9.8zm4.7 5.9c-.2 0-.4-.2-.4-.4.2-.7.7-1.3 1.4-1.4 0 1.4-.6 1.8-1 1.8z"
})));
export default SvgIconZegalSignTeal;